<template>
  <v-form
  class="mx-10 mb-10 pa-10 text-center"
    ref="form"
    v-model="valid"
    lazy-validation>

    <h3 class="text-left mb-5 text-primary">Sign</h3>
    <v-layout>
      <v-flex md4 wrap>
        <v-select
            background-color="rgba(255,255,255)"
            v-model="certificateSelected"
            :items="certificateList"
            item-text="cert.subject.DN"
            item-value="cert"
            label="Select Certificate"
            @change="changeCertificate"
            outlined
            dense
        ></v-select>
        <v-layout>
          <v-flex>
            <v-text-field
                background-color="rgba(255,255,255)"
                v-model="text"
                label="DataToSign"
                dense
                outlined
            ></v-text-field>
            <v-text-field
                background-color="rgba(255,255,255)"
                v-model="selectKeystore"
                label="KeyStoreId"
                outlined
                dense
            ></v-text-field>
            <v-autocomplete
                background-color="rgba(255,255,255)"
                v-model="algorithm"
                :items="algorithmOPTIONS"
                label="Algorithm"
                dense
                outlined
            ></v-autocomplete>
          </v-flex>
          <v-flex>
            <v-text-field
                background-color="rgba(255,255,255)"
                v-model="params"
                label="Sign Params"
                dense
                outlined
            ></v-text-field>
            <v-text-field
              background-color="rgba(255,255,255,0.2)"
              v-model="certificate"
              label="Certificate"
              dense
              outlined
          ></v-text-field>
            <v-autocomplete
              background-color="rgba(255,255,255,0.2)"
              v-model="selectProfile"
              :items="profileOPTIONS"
              item-text="name"
              item-value="id"
              label="Profile"
              outlined
              dense
          ></v-autocomplete>
            <v-select
              background-color="rgba(255,255,255,0.2)"
              v-model="format"
              :items="formatItems"
              label="Format"
              dense
              outlined
          ></v-select>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-textarea
        background-color="#999999"
              name="input-7-1"
            label="Parameters"
            class="mt-10"
            no-resize
            height="150px"
            v-model="requestPayload"
            outlined
        ></v-textarea>
      </v-flex>
      <v-flex md2>
        <v-btn
            :disabled="!valid"
            color="#007CA4"
            dark
            @click="pushGetSignature">
          Get Signature >>
        </v-btn>
      </v-flex>
      <v-flex md6 style="background-color: white">
        <vue-json-pretty :path="'res'" :data=this.response> </vue-json-pretty>
      </v-flex>
    </v-layout>

  </v-form>
</template>
<script>

import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';

import * as testingData from '../datas/testingDatas.js'
import { mapMutations } from 'vuex'
import alisonJS from  '@/services/alison_js.js'

  export default  {
    props: ['certList'],
    components: {
      VueJsonPretty,
    },
    data: () => ({
        text: '',
      dataToSignB64: null,
      certificate: null,
      certificateSelected: '',
      certificateList: [],
      signature: null,
      selectKeystore: null,
      selectProfile: '',
      algorithm: null,
      valid: true,
      format: null,
      params: null,
      formatItems: [],
      keystoresOPTIONS: [],
        algorithmOPTIONS: [],
      profileOPTIONS: [],
      requestPayload: '{}',
      response: null
    }),
    mounted(){
      this.certificateList= this.certList
      this.formatItems = Object.keys(testingData.signatureTypeOPTIONS)
      this.keystoresOPTIONS = this.objectToArray(testingData.keystoresOPTIONS)
      this.algorithmOPTIONS = this.objectToArray(testingData.algorithmOPTIONS)
      this.dataToSignB64 = [ 'bdc52be8192f6b0e01116d5a05aa12070643d15fd31ba524456e4e4587105b26'];
      this.updateRequest('dataToSignB64',null,this.dataToSignB64)
      this.updateRequest('algorithm',null,"SHA256withRSA")
    },
    watch: {
      selectKeystore(value){
        this.getKeyStoreInfo(value)
      },
      certList(){
        this.certificateList= this.certList
      },
      dataToSignB64(value) {
        this.updateRequest('dataToSignB64', null, value)
      },
      certificate(value){
        this.updateRequest('signingCertificate', 'thumbPrint', value)
      },
      selectKeystore(value){
        this.updateRequest('signingCertificate','keyStoreId', value)
      },
      selectProfile(value){
        this.updateRequest('signingCertificate','profileName', value)
      },
      algorithm(value){
        this.updateRequest('algorithm', null, value)
      },
      format(value){
        this.updateRequest('format', null, value)
      },
      params(value){
        this.updateRequest('extraParams', null, value)
      }
    },
    methods: {
      ...mapMutations({
        setSnack: 'setSnack',
        setColor: 'setColor'
      }),
      updateRequest(key1, key2, param){
        let request = JSON.parse(this.requestPayload)
        if(key2){
          if(!request[key1]) request[key1] = {}
          request[key1][key2] = param;
        }else{
          request[key1] = param;
        }
        this.requestPayload = JSON.stringify(request, null, "\t");
      },
      pushSign() {
        if (this.$refs.form.validate()) {
          this.sign()
        }
      },
      pushGetSignature() {
        if (this.$refs.form.validate()) {
          this.getSignature()
        }
      },
      changeCertificate(cert){
        this.certificate = this.certificateSelected.thumbPrint
        this.selectKeystore = this.certificateSelected.keyStoreId
        this.selectProfile = this.certificateSelected.profile.name
      },
      sign() {
          alisonJS.sign(JSON.parse(this.requestPayload)).then((_signature) => {
                this.setColor('success')
                this.setSnack('Signed successfully')
            this.response = _signature;
            this.signature = JSON.stringify(_signature,null, "\t");
          })
      },
      getSignature() {
          alisonJS.getSignatures(JSON.parse(this.requestPayload)).then((result) => {
                this.setColor('success')
                this.setSnack('Signed successfully')
            this.response = result;
            this.signature = JSON.stringify(result,null, "\t");
          }, (e) => {
          this.setColor('error')
          if (e.code && (e.detail || e.message)) {
              if (e.message) {
                this.setSnack('ERROR ' + e.message)
              } else {
                this.setSnack('ERROR '+ e.code +': ' + e.detail)
              }
          } else {
            this.setSnack('FAILURE: ' + JSON.stringify(e))
          }
          this.response = e;
        })
      },
      objectToArray(objectValue){
        let newArray = []
        Object.keys(objectValue).forEach(element => {
          newArray.push({text: objectValue[element], value: element})
        });
        return newArray
      },
      getKeyStoreInfo(keystoreId) {
          alisonJS.keyStoreInfo({id:keystoreId}).then((info) => {
              this.setColor('info')
              this.setSnack('KeyStore info obtained successfully')
              this.profileOPTIONS = info.keyStore.profiles;
          }).catch(e=>{
            this.setColor('error')
            if(e.code && (e.detail || e.message)){
              if(e.message){ this.setSnack('ERROR ' + e.message) }
              else { this.setSnack('ERROR '+ e.code +': ' + e.detail) }
            }else{
              this.setSnack('FAILURE: ' + JSON.stringify(e))
            }
            this.response = e;
            this.response = JSON.stringify(e, null, "\t");
          })
      }
    },
  }
</script>
<style scoped>
  .v-expansion-panel-header{
    background-color: #007CA4;
  }
</style>
